import axios, { AxiosResponse } from 'axios';

const Config = require('Config');

type FeedbackPayload = {
  user: {
    company: string;
    email: string;
    phone: string;
    firstname: string;
    lastname: string;
  },
  message: string;
  source: string;
  url: string;
  type: string;
  platform: string;
};

class FeedbackService {
  private feedbackServiceUrl: string;

  constructor() {
    this.feedbackServiceUrl = Config.feedbackServiceUrl;
  }

  async sendFeedback(payload: FeedbackPayload): Promise<void> {
    const response: AxiosResponse = await axios.post(this.feedbackServiceUrl, payload);
    if (response.status !== 200) {
      throw new Error();
    }
  }
}

export default new FeedbackService();
